export default __webpack_public_path__ + "static/media/string_representation.68038b82.jpg";